import React from 'react';
import {
  LuStar,
  LuUtensils,
  LuGraduationCap,
  LuBuilding2,
  LuPlane,
  LuCar,
  LuStore,
  LuHeartPulse,
  LuBriefcase,
  LuTarget,
  LuPercent,
  LuUsers,
  LuTrendingUp,
  LuMessageCircle,
  LuTrophy,
  LuChevronRight,
  LuArrowUpRight,
  LuArrowDownRight,
} from 'react-icons/lu';
import { FaWhatsapp } from 'react-icons/fa6';
// Konstanta WhatsApp
const WA_NUMBER = '6282337289588';
const WA_MESSAGE = 'Halo%20SriDesain%2C%20saya%20tertarik%20untuk%20konsultasi%20strategi%20iklan%20seperti%20case%20study%20berbagai%20industri';
const INDUSTRIES = [
  { icon: LuUtensils, label: 'Kuliner' },
  { icon: LuGraduationCap, label: 'Pendidikan' },
  { icon: LuBuilding2, label: 'Properti' },
  { icon: LuPlane, label: 'Travel' },
  { icon: LuCar, label: 'Otomotif' },
  { icon: LuStore, label: 'Retail' },
  { icon: LuHeartPulse, label: 'Kesehatan' },
  { icon: LuBriefcase, label: 'Jasa Lainnya' },
];

const CAMPAIGNS = [
  {
    tag: 'Kuliner',
    name: 'Gosyen Nagih Kriuk',
    image: '/campaigns/gosyen.jpg',
    chat: '127',
    cost: 'Rp1.371',
    ctr: '5.78%',
  },
  {
    tag: 'Pendidikan',
    name: 'Penerimaan Mahasiswa',
    image: '/campaigns/penerimaan.png',
    chat: '151',
    cost: 'Rp4.631',
    ctr: '2.45%',
  },
  {
    tag: 'Properti',
    name: 'Perumahan Fortuna',
    image: '/campaigns/fortuna.png',
    chat: '46',
    cost: 'Rp32.604',
    ctr: '1.02%',
  },
  {
    tag: 'Travel',
    name: 'Arin Samira Travel',
    image: '/campaigns/travel.jpg',
    chat: '78',
    cost: 'Rp8.774',
    ctr: '0.87%',
  },
  {
    tag: 'Jasa',
    name: 'Glow Up Clean',
    image: '/campaigns/clean.jpg',
    chat: '68',
    cost: 'Rp10.048',
    ctr: '1.07%',
  },
];

const BOTTOM_STATS = [
  { icon: LuUsers, value: '50+', label: 'Campaign Berjalan' },
  { icon: LuTrendingUp, value: 'Berbagai Industri', label: 'Ditangani' },
  { icon: LuMessageCircle, value: '2.500+', label: 'Chat Customer' },
  { icon: LuTarget, value: 'Strategi Tepat', label: 'Hasil Terukur' },
  { icon: LuTrendingUp, value: 'Pertumbuhan', label: 'Bisnis Nyata' },
];

function CampaignCard({ c }) {
  return (
    <div className="flex flex-col overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-sm shadow-slate-200/40 transition hover:-translate-y-0.5 hover:shadow-md">
      <div className="relative aspect-[4/3] w-full overflow-hidden">
        <img src={c.image} alt={c.name} className="h-full w-full object-cover" />
        <span className="absolute left-2.5 top-2.5 rounded-full bg-[#0F172A] px-2.5 py-1 text-[9px] font-extrabold uppercase tracking-wide text-amber-400">
          {c.tag}
        </span>
      </div>

      <div className="flex flex-1 flex-col gap-3 p-4">
        <div>
          <p className="text-sm font-bold leading-tight text-[#0F172A]">{c.name}</p>
          <p className="text-[11px] text-slate-400">Objective: Messaging</p>
        </div>

        <div className="flex flex-col gap-2.5 border-t border-slate-100 pt-3">
          <div className="flex items-center gap-2">
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-green-50 text-green-600">
              <FaWhatsapp className="h-3.5 w-3.5" />
            </span>
            <div className="leading-tight">
              <p className="text-sm font-bold text-[#0F172A]">{c.chat}</p>
              <p className="text-[10px] text-slate-400">Messaging Conversation</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-amber-50 text-amber-600">
              <LuTarget className="h-3.5 w-3.5" />
            </span>
            <div className="leading-tight">
              <p className="text-sm font-bold text-[#0F172A]">{c.cost}</p>
              <p className="text-[10px] text-slate-400">Cost per Result</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-slate-100 text-slate-500">
              <LuPercent className="h-3.5 w-3.5" />
            </span>
            <div className="leading-tight">
              <p className="text-sm font-bold text-[#0F172A]">{c.ctr}</p>
              <p className="text-[10px] text-slate-400">CTR (All)</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const CaseStudy4Section = () => {
  return (
    <section className="relative overflow-hidden bg-white px-4 py-14 md:px-6 lg:px-10 lg:py-20">
      {/* Ambient glow */}
      <div className="pointer-events-none absolute -top-32 right-0 h-[550px] w-[550px] rounded-full bg-amber-100/60 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 left-0 h-72 w-72 rounded-full bg-slate-100/70 blur-3xl" />

      <div className="relative mx-auto max-w-7xl">
        {/* Badge */}
        <span className="inline-flex items-center gap-2 rounded-full bg-amber-400 px-4 py-1.5 text-xs font-extrabold uppercase tracking-wide text-[#0F172A]">
          <LuStar className="h-3.5 w-3.5 fill-[#0F172A]" />
          Case Study 4
        </span>

        {/* Header row: headline + hero visual */}
        <div className="mt-6 grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-8">
          {/* Left: headline + subtext (wrapped as a single column block) */}
          <div>
            <h2 className="font-[var(--font-display)] text-2xl font-black uppercase leading-[1.15] tracking-tight text-[#0F172A] sm:text-3xl lg:text-[2.1rem]">
              Berhasil di Berbagai Industri,{' '}
              <span className="text-amber-500">
                Strategi yang Selalu Disesuaikan
              </span>{' '}
              Untuk Hasil Maksimal.
            </h2>
            <div className="mt-3 h-1.5 w-16 rounded-full bg-amber-400" />

            <p className="mt-4 max-w-xl text-sm leading-relaxed text-slate-600 sm:text-base">
              Setiap bisnis memiliki target, audiens, dan tantangan yang berbeda.
              SriDesain merancang{' '}
              <span className="font-semibold text-amber-600">
                strategi iklan yang tepat
              </span>{' '}
              untuk membantu berbagai industri mendapatkan lebih banyak customer dan{' '}
              <span className="font-semibold text-amber-600">
                pertumbuhan yang nyata.
              </span>
            </p>
          </div>

          {/* Right: hero visual */}
          <div className="relative mx-auto w-full max-w-md lg:mr-0">
            <div className="pointer-events-none absolute -inset-6 rounded-[2.5rem] bg-gradient-to-br from-amber-100/70 via-orange-50/40 to-transparent blur-2xl" />

            <div className="relative aspect-[4/3.6] w-full overflow-hidden rounded-[2rem]">
              <img
                src="/hero-case4.png"
                alt="Klien SriDesain menunjukkan performa iklan yang terus tumbuh"
                className="h-full w-full object-cover"
                style={{
                  maskImage:
                    'radial-gradient(ellipse 100% 100% at center, black 85%, transparent 100%)',
                  WebkitMaskImage:
                    'radial-gradient(ellipse 100% 100% at center, black 85%, transparent 100%)',
                }}
              />
            </div>

            {/* Overall performance card */}
            <div className="absolute left-0 top-4 w-40 rounded-xl border border-slate-100/80 bg-white/95 px-3.5 py-3 shadow-lg shadow-slate-200/50 backdrop-blur-sm sm:-translate-x-4">
              <p className="text-[10px] font-semibold text-slate-500">Overall Performance</p>
              <p className="text-[9px] text-slate-400">vs last 30 days</p>
              <div className="mt-2 border-t border-slate-100 pt-2">
                <p className="text-[10px] text-slate-400">Total Chat</p>
                <p className="text-lg font-extrabold text-[#0F172A]">2.500+</p>
                <p className="flex items-center gap-0.5 text-[10px] font-semibold text-green-600">
                  <LuArrowUpRight className="h-3 w-3" /> +182%
                </p>
              </div>
            </div>

            {/* Cost per result card */}
            <div className="absolute bottom-6 left-0 w-40 rounded-xl border border-amber-200 bg-amber-50/95 px-3.5 py-3 shadow-lg shadow-amber-100/60 backdrop-blur-sm sm:-translate-x-4">
              <p className="text-[10px] font-semibold text-slate-600">Cost per Result</p>
              <p className="mt-1 text-lg font-extrabold text-[#0F172A]">Rp2.380</p>
              <p className="flex items-center gap-0.5 text-[10px] font-semibold text-green-600">
                <LuArrowDownRight className="h-3 w-3" /> -36%{' '}
                <span className="font-normal text-slate-400">vs last 30 days</span>
              </p>
            </div>

            {/* Platform badges */}
            <div className="absolute -right-2 top-6 flex flex-col gap-3 sm:right-0">
              <div className="flex flex-col items-center gap-1 rounded-xl border border-slate-100 bg-white px-3 py-2.5 shadow-md shadow-slate-200/50">
                <span className="text-lg font-bold text-[#1877F2]">∞</span>
                <p className="text-[9px] font-medium text-slate-500">Meta Ads</p>
              </div>
              <div className="flex flex-col items-center gap-1 rounded-xl border border-slate-100 bg-white px-3 py-2.5 shadow-md shadow-slate-200/50">
                <span className="text-lg font-bold text-[#4285F4]">G</span>
                <p className="text-[9px] font-medium text-slate-500">Google Ads</p>
              </div>
            </div>
          </div>
        </div>

        {/* Industry icons row */}
        <div className="mt-10 grid grid-cols-4 gap-4 sm:grid-cols-8">
          {INDUSTRIES.map(({ icon: Icon, label }) => (
            <div key={label} className="flex flex-col items-center gap-2 text-center">
              <span className="flex h-14 w-14 items-center justify-center rounded-full border-2 border-amber-300 text-[#0F172A]">
                <Icon className="h-6 w-6" />
              </span>
              <p className="text-xs font-medium text-slate-600">{label}</p>
            </div>
          ))}
        </div>

        {/* Campaign cards */}
        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5">
          {CAMPAIGNS.map((c) => (
            <CampaignCard key={c.name} c={c} />
          ))}
        </div>

        {/* Bottom stat strip */}
        <div className="mt-10 grid grid-cols-1 gap-5 rounded-2xl border border-amber-200 bg-amber-50/40 px-6 py-5 sm:grid-cols-2 lg:grid-cols-5">
          {BOTTOM_STATS.map(({ icon: Icon, value, label }) => (
            <div key={label} className="flex items-center gap-3">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white text-amber-600 shadow-sm">
                <Icon className="h-5 w-5" />
              </span>
              <p className="leading-tight">
                <span className="block text-sm font-bold text-[#0F172A]">{value}</span>
                <span className="block text-xs text-slate-500">{label}</span>
              </p>
            </div>
          ))}
        </div>

        {/* Closing CTA bar - signature navy */}
        <div className="relative mt-10 flex flex-col items-center gap-4 overflow-hidden rounded-2xl bg-[#0F172A] px-6 py-5 shadow-xl shadow-slate-300/40 sm:flex-row sm:justify-between">
          <div className="pointer-events-none absolute -left-8 -top-10 h-40 w-40 rounded-full bg-amber-400/10 blur-3xl" />

          <div className="relative flex items-center gap-3.5">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-amber-400 text-[#0F172A]">
              <LuTrophy className="h-6 w-6" />
            </span>
            <p className="text-sm leading-snug text-white sm:text-base">
              Berbagai Bisnis, Satu Tujuan:
              <br />
              <span className="font-extrabold text-amber-400">
                Lebih Banyak Customer &amp; Omzet Tumbuh!
              </span>
            </p>
          </div>

          <a
            href={`https://wa.me/${WA_NUMBER}?text=${WA_MESSAGE}`}
            target="_blank"
            rel="noopener noreferrer"
            className="relative flex w-full shrink-0 items-center gap-4 rounded-full bg-amber-400 py-2 pl-5 pr-2 shadow-lg shadow-amber-500/30 transition hover:bg-amber-500 hover:scale-105 sm:w-auto"
          >
            <span className="text-left leading-tight">
              <span className="block text-xs font-extrabold uppercase tracking-wide text-[#0F172A] sm:text-sm">
                Konsultasi Strategi Iklan Gratis
              </span>
              <span className="block text-[10px] text-[#0F172A]/70">
                Analisis · Rekomendasi · Strategi · Hasil Optimal
              </span>
            </span>
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#0F172A] text-amber-400">
              <LuChevronRight className="h-5 w-5" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default CaseStudy4Section;